export default __webpack_public_path__ + "static/media/glyphs-no-2.62c476c0.ogg";